export const BACKEND_API_URL = process.env.FORGE_BACKEND_API_URL + '/api/v1';
export const BACKEND_API_URL_V2 = process.env.FORGE_BACKEND_API_URL + '/api/v2';

export const isProdBuild = process.env.ENV_TYPE === 'production';
export const isStagingBuild = process.env.ENV_TYPE === 'staging';
export const isDevBuild = process.env.ENV_TYPE === 'dev';
export const isTestBuild = process.env.ENV_TYPE === 'test';
export const isAutomationBuild = process.env.ENV_TYPE === 'automation';
